export function getCurrentZodiacSign() {
  const date = new Date();
  const day = date.getDate();
  const month = date.getMonth() + 1; // Months are 0-indexed

  if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return "Aries";
  if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return "Taurus";
  if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return "Gemini";
  if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return "Cancer";
  if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return "Leo";
  if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return "Virgo";
  if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return "Libra";
  if ((month === 10 && day >= 23) || (month === 11 && day <= 21))
    return "Scorpio";
  if ((month === 11 && day >= 22) || (month === 12 && day <= 21))
    return "Sagittarius";
  if ((month === 12 && day >= 22) || (month === 1 && day <= 19))
    return "Capricorn";
  if ((month === 1 && day >= 20) || (month === 2 && day <= 18))
    return "Aquarius";
  if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) return "Pisces";

  return null; // Should not happen with valid dates
}

// src/utils/zodiacData.js

export const zodiacData = {
  Aries: {
    element: "Fire",
    modality: "Cardinal",
    rulingPlanet: "Mars", // Modern & Traditional ruler
    glyph: "♈︎",
    keywords: ["Assertive", "Energetic", "Impulsive", "Leader", "Courageous"],
  },
  Taurus: {
    element: "Earth",
    modality: "Fixed",
    rulingPlanet: "Venus",
    glyph: "♉︎",
    keywords: ["Stable", "Sensual", "Reliable", "Patient", "Persistent"],
  },
  Gemini: {
    element: "Air",
    modality: "Mutable",
    rulingPlanet: "Mercury",
    glyph: "♊︎",
    keywords: [
      "Communicative",
      "Curious",
      "Adaptable",
      "Witty",
      "Intellectual",
    ],
  },
  Cancer: {
    element: "Water",
    modality: "Cardinal",
    rulingPlanet: "Moon",
    glyph: "♋︎",
    keywords: [
      "Nurturing",
      "Sensitive",
      "Protective",
      "Emotional",
      "Intuitive",
    ],
  },
  Leo: {
    element: "Fire",
    modality: "Fixed",
    rulingPlanet: "Sun",
    glyph: "♌︎",
    keywords: ["Charismatic", "Confident", "Generous", "Dramatic", "Warm"],
  },
  Virgo: {
    element: "Earth",
    modality: "Mutable",
    rulingPlanet: "Mercury",
    glyph: "♍︎",
    keywords: [
      "Analytical",
      "Practical",
      "Modest",
      "Helpful",
      "Detail-oriented",
    ],
  },
  Libra: {
    element: "Air",
    modality: "Cardinal",
    rulingPlanet: "Venus",
    glyph: "♎︎",
    keywords: ["Diplomatic", "Charming", "Fair", "Sociable", "Harmonious"],
  },
  Scorpio: {
    element: "Water",
    modality: "Fixed",
    rulingPlanet: "Pluto", // Modern ruler
    traditionalRuler: "Mars",
    glyph: "♏︎",
    keywords: [
      "Intense",
      "Mysterious",
      "Powerful",
      "Perceptive",
      "Transformative",
    ],
  },
  Sagittarius: {
    element: "Fire",
    modality: "Mutable",
    rulingPlanet: "Jupiter",
    glyph: "♐︎",
    keywords: [
      "Optimistic",
      "Adventurous",
      "Honest",
      "Philosophical",
      "Free-spirited",
    ],
  },
  Capricorn: {
    element: "Earth",
    modality: "Cardinal",
    rulingPlanet: "Saturn",
    glyph: "♑︎",
    keywords: [
      "Ambitious",
      "Disciplined",
      "Responsible",
      "Patient",
      "Practical",
    ],
  },
  Aquarius: {
    element: "Air",
    modality: "Fixed",
    rulingPlanet: "Uranus", // Modern ruler
    traditionalRuler: "Saturn",
    glyph: "♒︎",
    keywords: [
      "Unconventional",
      "Intellectual",
      "Independent",
      "Humanitarian",
      "Innovative",
    ],
  },
  Pisces: {
    element: "Water",
    modality: "Mutable",
    rulingPlanet: "Neptune", // Modern ruler
    traditionalRuler: "Jupiter",
    glyph: "♓︎",
    keywords: [
      "Compassionate",
      "Imaginative",
      "Intuitive",
      "Gentle",
      "Adaptable",
    ],
  },
};

// Optional helper function if needed elsewhere, but direct import is fine too
export function getZodiacDetails(signName) {
  // Basic check to ensure the sign exists in our data
  if (zodiacData.hasOwnProperty(signName)) {
    return zodiacData[signName];
  }
  console.warn(`Zodiac sign "${signName}" not found in zodiacData.`);
  return null; // Return null or a default object if the sign isn't found
}
